import store from '@/store'
export default {
  // 车间型号
  className: 'Mark',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '麦头名称不可为空'
      ]
    }
  ],
  search: [
    'name'
  ],
  hooks: {
  },
  action: {
    create: store.state.user && store.state.user.authority.allMark.create ? {} : false,
    edit: store.state.user && store.state.user.authority.allMark.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.allMark.del ? {} : false
  }
}
